"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangePicker = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var StyledSmart_1 = require("./StyledSmart");
var smartDate_1 = require("./smartDate");
exports.RangePicker = function (_a) {
    var smartDateType = _a.smartDateType, datePickerType = _a.datePickerType, whitelist = _a.whitelist, setStartDate = _a.setStartDate, setEndDate = _a.setEndDate, setSmartDateType = _a.setSmartDateType;
    var smartDatesForType = smartDate_1.SmartDates.get(datePickerType);
    var handleSelectSmartDate = function (newSmartDate) {
        var smartDateValue = smartDatesForType === null || smartDatesForType === void 0 ? void 0 : smartDatesForType.get(newSmartDate);
        if (smartDateValue) {
            setStartDate(smartDateValue.startDate);
            if (smartDateValue.endDate) {
                setEndDate(smartDateValue.endDate);
            }
            setSmartDateType(newSmartDate);
        }
    };
    var options;
    if (whitelist) {
        options = Object.entries(smartDate_1.SmartDateTypeOptions).filter(function (_a) {
            var key = _a[0], value = _a[1];
            return whitelist.includes(value);
        });
    }
    else {
        options = Object.entries(smartDate_1.SmartDateTypeOptions);
    }
    var smartDateListItems = options.map(function (_a) {
        var key = _a[0], value = _a[1];
        var dateRangeLabel = value;
        var active = smartDateType === value;
        return (react_1.default.createElement(StyledSmart_1.StyledSelectableListItem, { key: key, "data-testid": key, onClick: function () { return handleSelectSmartDate(dateRangeLabel); }, label: react_1.default.createElement(StyledSmart_1.SelectableListItemText, null, dateRangeLabel), isSelected: active }));
    });
    return (react_1.default.createElement(StyledSmart_1.StyledRangePicker, null,
        react_1.default.createElement(StyledSmart_1.StyledLabel, null, "Smart Dates"),
        smartDateListItems));
};
